import Component from './component'
import {connect} from 'react-redux'

export default connect()(Component)


// WEBPACK FOOTER //
// ./src/views/website/empreendimento/container.js